import { extractArrayFromQuery } from '../../../utils/query';

export default {
  param: extractArrayFromQuery,
  having: function (values) {
    if (values.length > 0) {
      return {
        $or: values.map(function(value) {
          return {
            1: {
              numberOfUploads: {
                $gte: 1
              }
            },
            2: {
              numberOfUploads: {
                $equals: 0
              }
            }
          }[value];
        })
      }
    }
  }
}
